module.exports = require("./kab-DZ.js");